module.exports = __webpack_public_path__ + "static/media/jejakin-marketplace.e6d10c00.svg";